import React from 'react';
import NavigationModel from '../../../../components/CustomNavigation/NavigationModel';

const FeeTransferNavigation = () => {
  const phpNavigationUrl = process.env.REACT_APP_PHP_URL;
  const cred = localStorage.getItem('cred');
  const userId = cred ? JSON.parse(cred)?.profile?.userId : null;
  const redirectUrl = `${phpNavigationUrl}/feetransfer/index/0`;
  return <NavigationModel redirectUrl={redirectUrl} title="Fee Transfer" navigationTo={'Old Portal'} />;
};

export default FeeTransferNavigation;
